// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file whatsapp.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact, ContactJson } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { WhatsappMessageKind, WhatsappMessageKindJson, WhatsappMessageStatus, WhatsappMessageStatusJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { UserRef, UserRefJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file whatsapp.proto.
 */
export const file_whatsapp: GenFile = /*@__PURE__*/
  fileDesc("Cg53aGF0c2FwcC5wcm90bxIJcmFjY29vbmFpIu8CCg9XaGF0c2FwcE1lc3NhZ2USCgoCaWQYASACKAQSEQoJZGlyZWN0aW9uGAIgAigJEgwKBGJvZHkYAyACKAkSHAoJYnV0dG9uX2lkGAQgASgJUglidXR0b25faWQSIwoHY29udGFjdBgFIAEoCzISLnJhY2Nvb25haS5Db250YWN0EjoKCmNyZWF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0EiwKBGtpbmQYByABKA4yHi5yYWNjb29uYWkuV2hhdHNhcHBNZXNzYWdlS2luZBIwCgZzdGF0dXMYCCABKA4yIC5yYWNjb29uYWkuV2hhdHNhcHBNZXNzYWdlU3RhdHVzEiIKBmF1dGhvchgJIAEoCzISLnJhY2Nvb25haS5Vc2VyUmVmEiwKEWNsaWVudF9tZXNzYWdlX2lkGAsgASgJUhFjbGllbnRfbWVzc2FnZV9pZCKTAQoTV2hhdHNhcHBNZXNzYWdlTGlzdBIsCghtZXNzYWdlcxgBIAMoCzIaLnJhY2Nvb25haS5XaGF0c2FwcE1lc3NhZ2USTgoUcmVwbHlfd2luZG93X2VuZHNfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUhRyZXBseV93aW5kb3dfZW5kc19hdEIGWgQuL3Bi", [file_contact, file_enums, file_general, file_google_protobuf_timestamp]);

/**
 * @generated from message raccoonai.WhatsappMessage
 */
export type WhatsappMessage = Message<"raccoonai.WhatsappMessage"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string direction = 2;
   */
  direction: string;

  /**
   * @generated from field: required string body = 3;
   */
  body: string;

  /**
   * @generated from field: optional string button_id = 4 [json_name = "button_id"];
   */
  buttonId: string;

  /**
   * @generated from field: optional raccoonai.Contact contact = 5;
   */
  contact?: Contact;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 6 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional raccoonai.WhatsappMessageKind kind = 7;
   */
  kind: WhatsappMessageKind;

  /**
   * Set on a dispatcher's message only.
   *
   * @generated from field: optional raccoonai.WhatsappMessageStatus status = 8;
   */
  status: WhatsappMessageStatus;

  /**
   * The dispatcher who wrote it; unset for the bot's and the client's messages.
   *
   * @generated from field: optional raccoonai.UserRef author = 9;
   */
  author?: UserRef;

  /**
   * The sender's idempotency key of a dispatcher's message.
   *
   * @generated from field: optional string client_message_id = 11 [json_name = "client_message_id"];
   */
  clientMessageId: string;
};

/**
 * @generated from message raccoonai.WhatsappMessage
 */
export type WhatsappMessageJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string direction = 2;
   */
  direction?: string;

  /**
   * @generated from field: required string body = 3;
   */
  body?: string;

  /**
   * @generated from field: optional string button_id = 4 [json_name = "button_id"];
   */
  button_id?: string;

  /**
   * @generated from field: optional raccoonai.Contact contact = 5;
   */
  contact?: ContactJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 6 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.WhatsappMessageKind kind = 7;
   */
  kind?: WhatsappMessageKindJson;

  /**
   * Set on a dispatcher's message only.
   *
   * @generated from field: optional raccoonai.WhatsappMessageStatus status = 8;
   */
  status?: WhatsappMessageStatusJson;

  /**
   * The dispatcher who wrote it; unset for the bot's and the client's messages.
   *
   * @generated from field: optional raccoonai.UserRef author = 9;
   */
  author?: UserRefJson;

  /**
   * The sender's idempotency key of a dispatcher's message.
   *
   * @generated from field: optional string client_message_id = 11 [json_name = "client_message_id"];
   */
  client_message_id?: string;
};

/**
 * Describes the message raccoonai.WhatsappMessage.
 * Use `create(WhatsappMessageSchema)` to create a new message.
 */
export const WhatsappMessageSchema: GenMessage<WhatsappMessage, {jsonType: WhatsappMessageJson}> = /*@__PURE__*/
  messageDesc(file_whatsapp, 0);

/**
 * @generated from message raccoonai.WhatsappMessageList
 */
export type WhatsappMessageList = Message<"raccoonai.WhatsappMessageList"> & {
  /**
   * @generated from field: repeated raccoonai.WhatsappMessage messages = 1;
   */
  messages: WhatsappMessage[];

  /**
   * For a job's dialogue: when WhatsApp's 24-hour customer-service window closes
   * (the client's last message + 24h). Unset when a reply cannot be sent: the window
   * has closed or the job has no dialogue.
   *
   * @generated from field: optional google.protobuf.Timestamp reply_window_ends_at = 2 [json_name = "reply_window_ends_at"];
   */
  replyWindowEndsAt?: Timestamp;
};

/**
 * @generated from message raccoonai.WhatsappMessageList
 */
export type WhatsappMessageListJson = {
  /**
   * @generated from field: repeated raccoonai.WhatsappMessage messages = 1;
   */
  messages?: WhatsappMessageJson[];

  /**
   * For a job's dialogue: when WhatsApp's 24-hour customer-service window closes
   * (the client's last message + 24h). Unset when a reply cannot be sent: the window
   * has closed or the job has no dialogue.
   *
   * @generated from field: optional google.protobuf.Timestamp reply_window_ends_at = 2 [json_name = "reply_window_ends_at"];
   */
  reply_window_ends_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.WhatsappMessageList.
 * Use `create(WhatsappMessageListSchema)` to create a new message.
 */
export const WhatsappMessageListSchema: GenMessage<WhatsappMessageList, {jsonType: WhatsappMessageListJson}> = /*@__PURE__*/
  messageDesc(file_whatsapp, 1);

